export function isDefinedOnQuery(node) {
    return node.typeCondition.name.value === 'Query';
}

//# sourceMappingURL=composableFragment.js.map